import styled from '@kawaui/theme'

import { BREAKPOINTS, headerHeight, isIE } from 'styles/constants'

export const Wrapper = styled.div`
  height: 100%;
  max-height: 100%;

  background: ${({ theme }) => theme.colors.white.s100};

  header {
    display: none;

    @media ${BREAKPOINTS.noMobile} {
      position: relative;

      z-index: unset;

      display: block;

      div > div:first-child {
        z-index: unset;
      }

      li {
        z-index: unset;
      }
    }
  }
`

export const LayoutWrapper = styled.div`
  display: flex;

  flex-wrap: wrap;
  flex-direction: column;
  min-width: 320px;
  height: 100%;

  background: ${({ theme }) => theme.colors.white.s100};

  @media ${BREAKPOINTS.noMobile} {
    overflow: auto;
    height: calc(100% - 120px);
  }

  @media ${isIE} {
    display: block;
  }
`

export const ComponentWrapper = styled.main`
  flex: 1;
  width: 100%;
  max-width: 1220px;
  height: 100%;
  padding: 0;
  margin: 0 auto;

  @media ${BREAKPOINTS.noMobile} {
    position: relative;
    z-index: 0;

    height: auto;

    padding: 32px 12px 48px;

    margin-top: ${headerHeight};
  }

  @media ${isIE} {
    display: block;
  }
`

export const HeaderWrapper = styled.div`
  position: fixed;
  z-index: 6;
  top: 0;

  width: 100%;
`
